import React from 'react'
import * as styles from './button.module.scss'
import classNames from 'classnames'
import arrowRightSvg from 'src/images/icons/arrow-right.svg'

export default function Button({
  children,
  className,
  onClick,
  theme = '',
  arrow = false,
  btn = false,
  disabled = false,
}) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={classNames(styles.button, className, {
        [styles[theme]]: theme,
        [styles.arrow]: arrow && !btn,
        [styles.btnArrow]: arrow && btn,
      })}
    >
      <span className={styles.text}>
        {children}
        {/* {arrow && !btn && (
          <img
            src={arrowRightSvg}
            width="44"
            height="18"
            alt="arrow pointing right"
          />
        )}

        {arrow && btn && (
          <svg
            width="24"
            height="19"
            viewBox="0 0 24 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.2071 0.474778C14.8166 0.0842537 14.1834 0.0842537 13.7929 0.474778C13.4024 0.865302 13.4024 1.49847 13.7929 1.88899L15.2071 0.474778ZM22.5 9.18188L23.2071 9.88899C23.5976 9.49847 23.5976 8.8653 23.2071 8.47478L22.5 9.18188ZM13.7929 16.4748C13.4024 16.8653 13.4024 17.4985 13.7929 17.889C14.1834 18.2795 14.8166 18.2795 15.2071 17.889L13.7929 16.4748ZM1.5 8.18188C0.947715 8.18188 0.5 8.6296 0.5 9.18188C0.5 9.73417 0.947715 10.1819 1.5 10.1819V8.18188ZM13.7929 1.88899L21.7929 9.88899L23.2071 8.47478L15.2071 0.474778L13.7929 1.88899ZM21.7929 8.47478L13.7929 16.4748L15.2071 17.889L23.2071 9.88899L21.7929 8.47478ZM22.5 8.18188H1.5V10.1819H22.5V8.18188Z"
              fill="#F6F5F1"
            />
          </svg>
        )} */}
      </span>
    </button>
  )
}
